export const INPUT_MANAGEMENT_METER_MONTH_MODEL_LIST = 'INPUT_MANAGEMENT_METER_MONTH_MODEL_LIST'
export const INPUT_MANAGEMENT_METER_MONTH_SEARCH = 'INPUT_MANAGEMENT_METER_MONTH_SEARCH'
export const INPUT_MANAGEMENT_METER_MONTH_PAGINATION = 'INPUT_MANAGEMENT_METER_MONTH_PAGINATION'
export const INPUT_MANAGEMENT_METER_MONTH_DROP_DOWN_SEARCH_TYPE = 'INPUT_MANAGEMENT_METER_MONTH_DROP_DOWN_SEARCH_TYPE'
export const INPUT_MANAGEMENT_METER_MONTH_DROP_DOWN_SEARCH_SOURCE = 'INPUT_MANAGEMENT_METER_MONTH_DROP_DOWN_SEARCH_SOURCE'

